/* HØLY · holy-film — owned timecode shoppable-video engine.
   Forked from Wonder shoppable-video.js + low-power-video.js (2026-06-26) and
   fully namespaced: custom elements <holy-film> / <holy-film-player>, selectors
   rescoped to .holy-film__*. Shares ZERO runtime identifiers with Wonder, so it
   can coexist with the pristine Wonder sections without collision.
   Behavior preserved 1:1: products sync to video timecode; scrolling the rail
   scrubs the video; play/pause + rewind. Overlay positioning is CSS (anchored). */
(function () {
  "use strict";

  if (!customElements.get("holy-film-player")) {
    customElements.define(
      "holy-film-player",
      class HolyFilmPlayer extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector("video");
          if (!this.video) return;
          // muted autoplay is permitted; tap is a fallback for blocked/low-power autoplay
          this._tap = function () {
            if (this.video && this.video.paused) this.video.play().catch(function () {});
          }.bind(this);
          this.addEventListener("click", this._tap, { passive: true });
          this.addEventListener("touchstart", this._tap, { passive: true });
        }
        disconnectedCallback() {
          this.removeEventListener("click", this._tap);
          this.removeEventListener("touchstart", this._tap);
        }
      }
    );
  }

  if (!customElements.get("holy-film")) {
    customElements.define(
      "holy-film",
      class HolyFilm extends HTMLElement {
        connectedCallback() {
          this.setup();
          if (!this.video || !this.rail) return;
          this.bind();
          this.listen();
        }
        disconnectedCallback() {
          this.unlisten();
        }

        setup() {
          try {
            this.info = JSON.parse(this.dataset.products || "{}");
          } catch (e) {
            this.info = {};
          }
          this.arr = Object.entries(this.info);
          this.video = this.querySelector("video");
          this.rail = this.querySelector(".holy-film__rail");
          this.control = this.querySelector(".holy-film__playpause");
          this.products = this.rail ? this.rail.querySelectorAll(".holy-film__product") : [];
          this.spacer = this.rail ? this.rail.querySelector(".holy-film__spacer") : null;
          this.rewinds = this.rail ? this.rail.querySelectorAll(".holy-film__rewind") : [];
          this.lastIdx = null;
          this.touching = false;
          this.dominant = 0;
          this.gap = 8;
          this.scrollTimer = null;
          this.sizeSpacer();
        }

        sizeSpacer() {
          if (!this.spacer || this.products.length < 2) return;
          var w = this.products[1].offsetWidth;
          this.gap = parseFloat(window.getComputedStyle(this.rail).getPropertyValue("gap")) || 8;
          this.spacer.style.width = "calc(100% - " + w + "px - " + this.gap + "px)";
        }

        bind() {
          this.togglePlay = this.togglePlay.bind(this);
          this.toggleIcon = this.toggleIcon.bind(this);
          this.onTime = this.throttle(this.onTime.bind(this), 250);
          this.onScroll = this.onScroll.bind(this);
          this.onTouch = this.onTouch.bind(this);
        }

        listen() {
          if (this.control) this.control.addEventListener("click", this.togglePlay);
          this.video.addEventListener("timeupdate", this.onTime);
          this.video.addEventListener("play", this.toggleIcon);
          this.video.addEventListener("pause", this.toggleIcon);
          this.rail.addEventListener("touchstart", this.onTouch, { passive: true });
          this.rail.addEventListener("scroll", this.onScroll, { passive: true });
          var self = this;
          this._rw = [];
          this.rewinds.forEach(function (b) {
            var h = function () { self.rewind(b); };
            b.addEventListener("click", h);
            self._rw.push({ b: b, h: h });
          });
        }

        unlisten() {
          if (this.control) this.control.removeEventListener("click", this.togglePlay);
          if (this.video) {
            this.video.removeEventListener("timeupdate", this.onTime);
            this.video.removeEventListener("play", this.toggleIcon);
            this.video.removeEventListener("pause", this.toggleIcon);
          }
          if (this.rail) {
            this.rail.removeEventListener("touchstart", this.onTouch);
            this.rail.removeEventListener("scroll", this.onScroll);
          }
          (this._rw || []).forEach(function (o) { o.b.removeEventListener("click", o.h); });
        }

        onTouch() {
          if (this.video) this.video.pause();
          this.touching = true;
        }

        onScroll() {
          this.updateDominant();
          if (!this.touching) return;
          if (this.scrollTimer) clearTimeout(this.scrollTimer);
          var self = this;
          this.scrollTimer = setTimeout(function () {
            var e = self.arr[self.dominant];
            if (!e) return;
            self.lastIdx = self.dominant - 1;
            self.video.currentTime = Number(e[1]) || 0;
            self.video.play().catch(function () {});
            self.touching = false;
          }, 250);
        }

        updateDominant() {
          var idx = -1, max = -1;
          var box = this.rail.getBoundingClientRect();
          this.products.forEach(function (p, i) {
            var r = p.getBoundingClientRect();
            var vis = Math.min(box.right, r.right) - Math.max(box.left, r.left);
            if (vis > max) { max = vis; idx = i; }
          });
          if (idx >= 0 && max / this.rail.offsetWidth > 0.2) this.dominant = idx;
        }

        onTime() {
          if (this.touching) return;
          var t = this.video.currentTime;
          var mobile = window.innerWidth <= 600;
          if (t < 1 && t > 0 && this.lastIdx !== 0) {
            this.lastIdx = 0;
            this.rail.scrollTo({ left: 0, behavior: "smooth" });
            return;
          }
          for (var i = this.lastIdx || 0; i < this.arr.length; i++) {
            var it = Number(this.arr[i][1]);
            if (!(t > it && t < it + 1) || !this.products[i]) continue;
            var target = mobile
              ? this.products[i].offsetLeft - 10
              : this.products[i].offsetLeft + this.products[i].offsetWidth - this.rail.offsetWidth + 20;
            target = Math.max(0, Math.min(target, this.rail.scrollWidth - this.rail.clientWidth));
            if (Math.abs(this.rail.scrollLeft - target) > 1) {
              this.lastIdx = i;
              this.animate(this.rail.scrollLeft, target, 250);
              break;
            }
          }
        }

        rewind(btn) {
          var s = this.info[btn.dataset.productIndex];
          if (s == null) return;
          this.video.currentTime = Number(s) || 0;
          this.video.play().catch(function () {});
        }

        togglePlay(e) {
          if (e) e.preventDefault();
          if (this.video.paused || this.video.ended) this.video.play().catch(function () {});
          else this.video.pause();
        }

        toggleIcon() {
          if (!this.control) return;
          var playing = !this.video.paused;
          this.control.classList.toggle("holy-film__playpause--playing", playing);
          this.control.classList.toggle("holy-film__playpause--paused", !playing);
        }

        throttle(fn, limit) {
          var on;
          return function () {
            var a = arguments, c = this;
            if (!on) { fn.apply(c, a); on = true; setTimeout(function () { on = false; }, limit); }
          };
        }

        animate(start, end, dur) {
          var rail = this.rail, t0 = performance.now();
          var ease = function (p) { return Math.sin((p * Math.PI) / 2); };
          function step(now) {
            var p = Math.min((now - t0) / dur, 1);
            rail.scrollLeft = start + (end - start) * ease(p);
            if (p < 1) requestAnimationFrame(step);
            else rail.scrollLeft = end;
          }
          requestAnimationFrame(step);
        }
      }
    );
  }
})();
